import { ReactNode } from "react";
import { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
import i18next from "i18next";

type PageProps = PropsWithChildren<{
  title: string;
  action?: ReactNode;
  back?: boolean;
  lngChange?: boolean;
}>;

function Page({ children, title, action, back, lngChange }: PageProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-dvh bg-background text-white">
      <div className="mx-auto flex h-full min-h-[100dvh] max-w-md flex-col p-5 ">
        <header className="flex h-[50px] flex-row items-center  gap-4">
          <div className="flex flex-row items-center space-x-2">
            {back && (
              <div onClick={() => navigate(-1)}>
                <FaChevronLeft />
              </div>
            )}
            <h1 className="font-sans text-xl font-bold">{title}</h1>
          </div>
          <div className="grow" />
          <div>
            {lngChange && (
              <button
                onClick={() =>
                  i18next.changeLanguage(
                    i18next.language === "en"
                      ? "it"
                      : i18next.language === "it"
                      ? "de"
                      : "en",
                  )
                }
              >
                {i18next.language === "en"
                  ? "ENG"
                  : i18next.language === "it"
                  ? "ITA"
                  : "DEU"}
              </button>
            )}
          </div>
        </header>
        <main className="flex grow flex-col">{children}</main>
        <div className="flex h-[100px] flex-col items-center justify-center">
          {action}
        </div>
      </div>
    </div>
  );
}

export function PageWithoutHeader({ children, action }: Partial<PageProps>) {
  return (
    <div className="h-dvh bg-secondary text-white">
      <div className="mx-auto flex h-full min-h-[100dvh] max-w-md flex-col p-5 ">
        <main className="flex grow flex-col">{children}</main>
        <div className="flex h-[100px] flex-col items-center justify-center">
          {action}
        </div>
      </div>
    </div>
  );
}

export default Page;
